import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import {
    CheckCircleIcon,
    ExclamationTriangleIcon,
    XCircleIcon,
} from '@heroicons/react/24/outline';

const StatusIcon = ({ status }) => {
    if (status === true) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        tabIndex={0}
                        role='img'
                        aria-label='Positieve registratie (JA)'
                        className='inline-flex'
                    >
                        <CheckCircleIcon className='size-5 text-green-600' />
                    </span>
                </TooltipTrigger>
                <TooltipContent>Positieve registratie (JA)</TooltipContent>
            </Tooltip>
        );
    }

    if (status === false) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        tabIndex={0}
                        role='img'
                        aria-label='Negatieve registratie (NEE)'
                        className='inline-flex'
                    >
                        <XCircleIcon className='size-5 text-orange-500' />
                    </span>
                </TooltipTrigger>
                <TooltipContent>Negatieve registratie (NEE)</TooltipContent>
            </Tooltip>
        );
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span
                    tabIndex={0}
                    role='img'
                    aria-label='Niet gecontroleerd'
                    className='inline-flex'
                >
                    <ExclamationTriangleIcon className='size-5 text-red-600' />
                </span>
            </TooltipTrigger>
            <TooltipContent>Niet gecontroleerd</TooltipContent>
        </Tooltip>
    );
};

export default StatusIcon;
